import React from 'react';
import { FormattedMessage } from 'react-intl';
import urls from '@/constants/urls';

const SearchInfo = () => (
  <div className="aridhia-search-info">
    <FormattedMessage id="search.hints" />
    {' '}
    <a href={urls.SEARCH_HELP} rel="noopener noreferrer" target="_blank">
      <FormattedMessage id="search.hints.info" />
    </a>
  </div>
);

export default SearchInfo;
